import { motion } from 'framer-motion'
import React, { useCallback } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import logo from './home/logo.png'

const variants = {
  visible: {
    top: 0,
  },
  hidden: {
    top: -200,
  },
}

const Navigation = ({ visible }) => {
  const location = useLocation()
  const history = useHistory()
  const onLogoClick = useCallback(() => {
    if (location.pathname !== '/' && history.length > 1) history.goBack()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [history, location])
  return (
    <motion.div
      initial='hidden'
      animate={visible ? 'visible' : 'hidden'}
      variants={variants}
      className='px-4 md:p-4 flex items-center justify-between fixed w-full text-xs md:text-base bg-white z-10 shadow-lg'
    >
      <button onClick={onLogoClick} className='focus:ring-0 focus:outline-none'>
        <span className='flex items-center'>
          <img className='inline' src={logo} alt='Poplink logo' width={50} height={50} />
          <span>PopLink</span>
        </span>
      </button>
      <div className=' ml-auto md:px-6 px-1'>
      <a
          href="https://dashboard.poplink.in"
          target='_blank'
          rel='noopener noreferrer'
          className='text-gray-900 hover:text-gray-700'
        >
          Login/SignUp
        </a>
      </div>
      <div className='md:px-6 px-1'>
        <Link to='/pricing' className='text-gray-900 hover:text-gray-700'>
          Pricing
        </Link>
      </div>
      <div className='md:px-6 px-1'>
        <a
          href='https://blog.poplink.in'
          target='_blank'
          rel='noopener noreferrer'
          className='text-gray-900 hover:text-gray-700'
        >
          Blog
        </a>
      </div>
      <div className='md:px-6 px-1'>
        <Link to='/about-us' className='text-gray-900 hover:text-gray-700'>
          About us
        </Link>
      </div>
    </motion.div>
  )
}

export default Navigation
